export default function SmoothScroll() {
  const buttons = document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]');

  buttons.forEach((button) => {
    button.addEventListener("click", (e) => {
      const href = button.getAttribute("href");
      if (!href || href === "#") return;
      e.preventDefault();
      const target = document.querySelector(href);
      if (target) {
        const targetTop =
          target.getBoundingClientRect().top + window.scrollY - 100;

        window.scrollTo({
          behavior: "smooth",
          top: targetTop,
        });
      }
    });
  });
}
